import { render } from "./MedicalOfficeRecruitmentPage.vue?vue&type=template&id=c380b0d6&scoped=true"
import script from "./MedicalOfficeRecruitmentPage.vue?vue&type=script&lang=js"
export * from "./MedicalOfficeRecruitmentPage.vue?vue&type=script&lang=js"

import "./MedicalOfficeRecruitmentPage.vue?vue&type=style&index=0&id=c380b0d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c380b0d6"]])

export default __exports__